/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse, AxiosRequestConfig } from 'axios'
import { CallEffect, PutEffect } from 'redux-saga/effects'
import { CSSProperties } from 'react'

type FontSizes = {
  descriptions: number
  customizations: number
}

export type Theme = {
  fontSizes: FontSizes
  footer: string
  splash: boolean
  imageSize: string
  categoryMenuStyle: string
  cartItemDescription: boolean
  cartItemImage: boolean
  sendButton: string
  customerColor: string
  logo: string
  focusColor: string
  searchIcon: string
  categoryButton: string
}

export type Webview = {
  customProducts: boolean
  region: string
  currencyFormat: string
  addProducts: boolean
  multiLeveCategories: boolean
  searchItems: boolean
  singlePage: boolean
  notesBox: boolean
  getExternalPrice: boolean
  pagination: boolean
  categoryPositions: string[]
  botSlugFb: string
  botSlug: string
  botNumber: string
  botState: string
  orderMinAmount: number
  provider: string
  currency: string
  currencyPrefix: string
  theme: Theme
}

export interface IFirebaseConfig {
  apiKey: string
  authDomain: string
  databaseURL?: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
  measurementId?: string
}

export type ClientWebview = {
  pageTitle: string
  initialData?: any
  submitData: any
  steps: any
}

export type Extensions = {
  webviewCustomizations?: {
    logo?: CSSProperties
    primaryButton?: CSSProperties
    unstyledButton?: CSSProperties
    backToChatButton?: CSSProperties
  }
  recaptchaSiteKey: string
  resetPasswordURL: string
  firebaseConfig: IFirebaseConfig
  sendLoginMiddleware?: AxiosRequestConfig
  sendToMiddleware?: AxiosRequestConfig
  sendToLoginFallbackMiddleware?: AxiosRequestConfig
  fetchClientDataMiddleware?: AxiosRequestConfig
  sendClientMiddleware?: AxiosRequestConfig
  sendAddressMiddleware?: AxiosRequestConfig
  fetchAddressDataMiddleware?: AxiosRequestConfig
  clientWebview: ClientWebview
}

export type Configuration = {
  isActive: boolean
  localization: string
  name: string
  slug: string
  country: string
  webview: Webview
  extensions: Extensions
}

export interface IFetchConfigurationPayload {
  slug: string
}

export type ConfigurationGeneratorYield =
  | CallEffect<AxiosResponse<Configuration>>
  | PutEffect<ISuccessFetchConfiguration | IFailFetchConfiguration>

export const FETCH_CONFIGURATION = 'FETCH_CONFIGURATION'
export const SUCCESS_FETCH_CONFIGURATION = 'SUCCESS_FETCH_CONFIGURATION'
export const FAIL_FETCH_CONFIGURATION = 'FAIL_FETCH_CONFIGURATION'

export interface IFetchConfiguration {
  type: typeof FETCH_CONFIGURATION
  payload: IFetchConfigurationPayload
}

export interface IFailFetchConfiguration {
  type: typeof FAIL_FETCH_CONFIGURATION
  payload: string
}

export interface ISuccessFetchConfiguration {
  type: typeof SUCCESS_FETCH_CONFIGURATION
  payload: Configuration
}

export type ConfigurationDispatchTypes = IFetchConfiguration | IFailFetchConfiguration | ISuccessFetchConfiguration
